import { motion } from "framer-motion";

const Datenschutz = () => {
    return (
        <section
            className="pt-32 md:pt-40 pb-20 md:pb-28"
            data-testid="datenschutz-page"
        >
            <div className="max-w-3xl mx-auto px-6 md:px-12">
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-xs uppercase tracking-[0.28em] text-ls-inkSoft font-sans mb-6"
                >
                    <span className="inline-block w-8 h-px bg-ls-ink align-middle mr-3" />
                    DSGVO
                </motion.p>
                <motion.h1
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    className="font-serif text-5xl md:text-7xl text-ls-ink tracking-tight mb-12"
                >
                    Datenschutz&shy;erklärung
                </motion.h1>

                <div className="space-y-10 font-sans text-ls-inkSoft leading-relaxed">
                    <Block title="1. Allgemeiner Hinweis">
                        Diese Datenschutzerklärung klärt Sie über die Art, den
                        Umfang und Zweck der Verarbeitung von personenbezogenen
                        Daten (nachfolgend kurz „Daten") innerhalb unseres
                        Onlineangebotes und der mit ihm verbundenen Webseiten,
                        Funktionen und Inhalte auf. Grundlage ist die
                        Datenschutz-Grundverordnung (DSGVO).
                    </Block>

                    <Block title="2. Verantwortlicher">
                        LS Design & Consulting, Inhaber: L. Schmidt,
                        Musterstraße 1, 10115 Berlin, Deutschland.
                        <br />
                        E-Mail: info@ls-dc.de
                    </Block>

                    <Block title="3. Erhebung und Speicherung personenbezogener Daten">
                        Beim Besuch unserer Website werden durch den Browser
                        automatisch Informationen an den Server unserer Website
                        gesendet (IP-Adresse, Datum/Uhrzeit, Browsertyp,
                        Betriebssystem, Referrer-URL). Diese Daten werden
                        temporär in einem Logfile gespeichert. Rechtsgrundlage
                        ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
                        an einer funktionalen, sicheren Website).
                    </Block>

                    <Block title="4. Kontaktformular und E-Mail-Kontakt">
                        Wenn Sie uns per Kontaktformular oder E-Mail
                        (info@ls-dc.de) Anfragen zukommen lassen, werden Ihre
                        Angaben aus dem Anfrageformular inklusive der von Ihnen
                        dort angegebenen Kontaktdaten zwecks Bearbeitung der
                        Anfrage und für den Fall von Anschlussfragen bei uns
                        gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. a
                        (Einwilligung) bzw. lit. b (Vertragsanbahnung) DSGVO.
                        Die Daten werden gelöscht, sobald sie für den Zweck
                        ihrer Erhebung nicht mehr erforderlich sind und keine
                        gesetzlichen Aufbewahrungspflichten entgegenstehen.
                    </Block>

                    <Block title="5. Hosting">
                        Diese Website wird bei einem professionellen
                        Hosting-Dienstleister in der Europäischen Union
                        gehostet. Es gelten strenge technische und
                        organisatorische Sicherheitsmaßnahmen. Die Server
                        erheben automatisch Daten (siehe Abschnitt 3).
                    </Block>

                    <Block title="6. Cookies">
                        Unsere Website verwendet Cookies. Notwendige Cookies
                        sind für den Betrieb der Website erforderlich
                        (Art. 6 Abs. 1 lit. f DSGVO). Optionale Cookies (z. B.
                        für Analyse) werden nur mit Ihrer ausdrücklichen
                        Einwilligung gesetzt (Art. 6 Abs. 1 lit. a DSGVO, § 25
                        Abs. 1 TTDSG). Ihre Einwilligung können Sie jederzeit
                        über unseren Cookie-Banner widerrufen.
                    </Block>

                    <Block title="7. Analyse-Tools">
                        Aktuell werden auf dieser Website keine externen
                        Analyse-Tools (z. B. Google Analytics) eingesetzt.
                        Sollte dies zukünftig erfolgen, werden wir diese
                        Datenschutzerklärung entsprechend aktualisieren und Ihre
                        Einwilligung einholen.
                    </Block>

                    <Block title="8. Ihre Rechte">
                        Sie haben jederzeit das Recht auf Auskunft (Art. 15
                        DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17
                        DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO),
                        Widerspruch (Art. 21 DSGVO) und Datenübertragbarkeit
                        (Art. 20 DSGVO). Sie können Ihre Einwilligung jederzeit
                        widerrufen. Außerdem haben Sie das Recht, sich bei einer
                        Aufsichtsbehörde zu beschweren.
                    </Block>

                    <Block title="9. Kontakt">
                        Für Fragen zum Datenschutz kontaktieren Sie uns unter{" "}
                        <a
                            href="mailto:info@ls-dc.de"
                            className="underline hover:text-ls-ink"
                        >
                            info@ls-dc.de
                        </a>
                        .
                    </Block>

                    <p className="text-xs italic text-ls-inkSoft/70 pt-6 border-t border-ls-ink/10">
                        Stand: {new Date().toLocaleDateString("de-DE")} · Diese
                        Datenschutzerklärung ist ein Muster und sollte vor
                        Live-Gang von einem Fachanwalt geprüft werden.
                    </p>
                </div>
            </div>
        </section>
    );
};

const Block = ({ title, children }) => (
    <div>
        <h2 className="font-serif text-2xl md:text-3xl text-ls-ink mb-3">
            {title}
        </h2>
        <p>{children}</p>
    </div>
);

export default Datenschutz;
